import React from "react";
import { useFETCH } from "../../Tools/APIs";
import { fileUrl } from "../../Tools/APIs";
import { Row, Col } from "../../Tools/Grid-system";
import Loading from "../../Tools/Loading";

export const FEATURES = [
  {
    key: "CHAT",
    name: "الدردشة",
  },
  {
    key: "PROFILE_VISITORS",
    name: "رؤية من زار بروفايلي",
  },
  {
    key: "CARES",
    name: "القدرة على اهتمام بشخص ما",
  },
  {
    key: "CHAT_NATIONALITIES",
    name: "القدرة على تحديد الجنسيات التي تراسلني",
  },
  {
    key: "CHAT_COUUNTRIES",
    name: "القدرة على تحديد البلدان التي تراسلني",
  },
  {
    key: "PREMIUM_SHOW",
    name: "الظهور في القائمة المميزة",
  },
  {
    key: "MANAGE_NOTIFICATIONS",
    name: "التحكم بالاشعارات التي تصلني",
  },
];

const MyPackages = () => {
  const { data, isLoading } = useFETCH("v1/packages/mine");
  const packages = data?.data?.data?.packages || [];
  const totalRemainingMessages = data?.data?.total_remaining_messages;

  if (isLoading) return <Loading />;

  return (
    <Col md={11} className="mx-auto space-y-4">
      {typeof totalRemainingMessages !== 'undefined' && (
        <div className="flex justify-center mb-6">
          <div className="bg-pink-500 text-white rounded-2xl px-6 py-3 shadow-lg text-xl font-bold flex items-center gap-3 animate-fade-in">
            <span className="inline-block bg-white/20 rounded-full px-3 py-1 text-lg font-semibold">💬</span>
            <span>إجمالي الرسائل المتبقية:</span>
            <span className="text-2xl font-extrabold ml-2">{totalRemainingMessages}</span>
          </div>
        </div>
      )}
      <h2 className="text-2xl font-bold my-6 text-pink-600">حزمك الحالية</h2>
      <Row className="gap-4">
        {packages.length === 0 && (
          <Col md={12} className="text-center text-gray-500 py-8">
            لا يوجد حزم حالية
          </Col>
        )}
        {packages.map((pkg) => (
          <Col key={pkg.id} md={6} lg={6}>
            <div className="relative flex w-full max-w-md flex-col rounded-xl bg-gradient-to-tr from-pink-100 to-pink-300 bg-clip-border p-6 md:p-8 text-gray-800 shadow-md shadow-pink-200/40 transition-all">
              {pkg.image && (
                <div className="relative mb-4 overflow-hidden rounded-xl bg-white/30 w-full">
                  <img src={pkg.image.startsWith('http') ? pkg.image : `${fileUrl}${pkg.image}`} alt={pkg.name} className="w-full h-32 object-cover" />
                </div>
              )}
              <div className="mb-2 w-full">
                <h3 className="font-bold text-lg mb-1 break-words w-full">{pkg.name}</h3>
                {/* <div className="text-xs text-gray-500 mb-2 break-words w-full">ID: {pkg.id}</div> */}
                <div className="flex flex-wrap gap-2 text-sm mb-2 w-full">
                  <span className="bg-pink-200 text-pink-800 rounded px-2 py-0.5 break-words">المدة: {pkg.duration} يوم</span>
                  <span className="bg-pink-200 text-pink-800 rounded px-2 py-0.5 break-words">الرسائل: {pkg.messages_count}</span>
                  <span className="bg-pink-200 text-pink-800 rounded px-2 py-0.5 break-words">المتبقي: {pkg.remaining_messages}</span>
                </div>
                <div className="flex items-center gap-2 mb-2 w-full">
                  <span className="text-green-700 font-bold text-lg break-words">${pkg.new_price}</span>
                  {pkg.old_price && <span className="line-through text-gray-400 break-words">${pkg.old_price}</span>}
                </div>
                <div className="text-xs text-gray-600 mb-2 break-words w-full">ساري حتى: {pkg.valid_until}</div>
                <div className="h-20 overflow-y-auto bg-white/40 rounded p-2 mb-2 w-full">
                  <div className="font-semibold text-pink-700 mb-1 break-words">المميزات:</div>
                  <ul className="list-disc list-inside text-sm break-words w-full">
                    {pkg.features.split(',').map((f, i) => {
                      const feature = FEATURES.find(feat => feat.key === f.trim());
                      return (
                        <li key={i} className="break-words w-full">{feature ? feature.name : f}</li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Col>
  );
};

export default MyPackages; 